'use strict';

define('lib/analytics/blocks/offer.list.block',[], function () {
  return function offerListBlock(offerList) {
    return {
      offer_list_result_count: offerList.count.toString(),
      offer_list_layout: offerList.layout || '',
      offer_list_filter: offerList.filter || '',
      offer_list_selector: offerList.selector || '',
    };
  };
});

